import { render, staticRenderFns } from "./add-supplier-dialog.vue?vue&type=template&id=25521486&scoped=true"
import script from "./add-supplier-dialog.vue?vue&type=script&lang=js"
export * from "./add-supplier-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-supplier-dialog.vue?vue&type=style&index=0&id=25521486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25521486",
  null
  
)

export default component.exports